import React from 'react'
import CertificateTable from './CertificateTable'
import { Card } from 'reactstrap'

const CertificateManagement = () => {
  return (
    <Card className='p-3'>
      <CertificateTable />
    </Card>
  )
}

export default CertificateManagement